import React from 'react';
import SwiperEngine from 'swiper/dist/js/swiper';

export const Swiper = React.createClass({
  getInitialState() {
    return {
      activeIndex: undefined
    }
  },
  componentWillMount() {
    this._updating = false;
    this._swiperUpdateNeeded = false;
  },
  componentDidMount() {
    if(!this.containerElement) {
      console.error('Swiper mounted with no ref to any slide container.');
      return;
    }
    const config = {
      ...this.props.config,
      /*onTransitionEnd(e) {
      },*/
      observer: true,
    }
    this.swiperEngine = new SwiperEngine(this.containerElement, config);
    this.props.onSwiperEngineCreated && this.props.onSwiperEngineCreated(this.swiperEngine);
    if(this.props.activeIndex) {
      //this.swiperEngine.slideTo(this.props.activeIndex)
    }     
  },
  componentWillUnmount() {
    if(this.swiperEngine) {
      this.swiperEngine.destroy();
    }
  },
  componentWillUpdate() {
    this._updating = true;
  },
  componentDidUpdate(prevProps) {
    if(this._swiperUpdateNeeded) {
      //this.swiperEngine.update();
    }
    this._swiperUpdateNeeded = false;
    this._updating = false;
    if(this.props.activeIndex) {
      //this.swiperEngine.slideTo(this.props.activeIndex)
    }    
  },
  handleRef(element) {
    this.containerElement = element;
  },
  handleSlideRef(element) {
    if(this._updating) {
      this._swiperUpdateNeeded = true;
    }
  },
  render() {
    return this.props.children({
      ref: this.handleRef,
      slideRef: this.handleSlideRef,
    })
  }
});


// WEBPACK FOOTER //
// ./src/visual/component/Swiper.js